import React from "react";

import {
  EyeOpenIcon,
  NewThreadIcon,
  NotebookViewIcon,
} from "../icons/CustomIcons";

/** Stable view ids for plain-code project shell tabs (do not rename). */
export const TAO_PROJECT_VIEW = {
  chat: "chat",
  code: "code",
  preview: "preview",
} as const;

export type TaoProjectView =
  (typeof TAO_PROJECT_VIEW)[keyof typeof TAO_PROJECT_VIEW];

export type TaoProjectViewDefinition = {
  readonly id: TaoProjectView;
  readonly label: string;
  readonly icon: React.ReactElement;
};

export const TAO_PROJECT_VIEW_DEFINITIONS: ReadonlyArray<TaoProjectViewDefinition> =
  [
    {
      id: TAO_PROJECT_VIEW.chat,
      label: "Agent",
      icon: <NewThreadIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.code,
      label: "Code",
      icon: <NotebookViewIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.preview,
      label: "Preview",
      icon: <EyeOpenIcon />,
    },
  ];

/** Explorers on an unlisted (or not yet loaded) Tao project get Agent and Preview only, mirroring `restrictProjectViewsForExplorer`. */
export function restrictTaoProjectViewsForExplorer({
  availableViews,
  isExplorer,
  isUnlisted,
}: {
  availableViews: ReadonlyArray<TaoProjectViewDefinition>;
  isExplorer: boolean;
  isUnlisted: boolean | undefined;
}): ReadonlyArray<TaoProjectViewDefinition> {
  if (!isExplorer || isUnlisted === false) {
    return availableViews;
  }
  return availableViews.filter((view) => view.id !== TAO_PROJECT_VIEW.code);
}

/** Max content width for the Chat tab agent UI (matches logic-view fullscreen threads). */
export const TAO_PROJECT_FULLSCREEN_CHAT_CONTENT_MAX_WIDTH = 760;
